<div class="redistribution-holder">
  <div class="body-wrapper" *ngIf="!isLoading">
    <div class="form-container" >

      <div class="row align-items-center">
        <div class="col-4">
          <div class="title-holder">
            <div class="icon">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.1641 1.0625V6.03516L11.9131 5.60449L15.4902 3.54785L17.3721 6.79297L13.7988 8.84766L13.0449 9.28125L13.7988 9.71484L17.3711 11.7686L15.4893 15.0146L11.9131 12.959L11.1641 12.5283V17.5H7.39746V12.5283L6.64844 12.959L3.07324 15.0137L1.19043 11.7686L4.76367 9.71484L5.51758 9.28125L4.76367 8.84766L1.19043 6.79297L3.07227 3.54785L6.64844 5.60449L7.39746 6.03516V1.0625H11.1641Z" fill="url(#paint0_linear_30739_3551)" stroke="url(#paint1_linear_30739_3551)"/>
                <defs>
                  <linearGradient id="paint0_linear_30739_3551" x1="9.28125" y1="0.562502" x2="-12.4127" y2="9.02092" gradientUnits="userSpaceOnUse">
                    <stop/>
                    <stop offset="1" stop-color="white"/>
                  </linearGradient>
                  <linearGradient id="paint1_linear_30739_3551" x1="15.051" y1="-0.778844" x2="6.04928" y2="7.55402" gradientUnits="userSpaceOnUse">
                    <stop stop-color="white" stop-opacity="0"/>
                    <stop offset="0.428115" stop-color="white" stop-opacity="0.81428"/>
                    <stop offset="1" stop-color="white" stop-opacity="0"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <h2 class="form-title">
              Запит на перерозподіл
            </h2>
          </div>
        </div>
        <div class="col-2" *ngIf="redistributionRequest?.status">
          <app-redistribution-status [status]="redistributionRequest['status']" />
        </div>
      </div>

      <div class="row">
        <div class="col-4">
          <div class="form-group">
            <span class="subtitle">Медичний товар</span>
            <p class="content" *ngIf="redistributionRequest">{{ redistributionRequest['tradeName'] }}</p>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group">
            <span class="subtitle">МНН</span>
            <p class="content">{{ redistributionRequest['mnn'] }}</p>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group">
            <span class="subtitle">Напрям</span>
            <p class="content">{{ redistributionRequest['direction'] }}</p>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group">
            <span class="subtitle">Дозування</span>
            <p class="content">{{ redistributionRequest['dosage'] === null ? '-' : redistributionRequest['dosage'] }}</p>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group">
            <span class="subtitle">Кількість у запиті</span>
            <p class="content">{{ redistributionRequest['amount'] === null ? '-' : redistributionRequest['amount'] }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-4">
          <div class="form-group">
            <span class="subtitle">Для закладу</span>
            <p class="content">{{ getOrganisationName(redistributionRequest.organizationId) }}</p>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group" *ngIf="redistributionRequest.status === 'CANCELLED'">
            <span class="subtitle">Причина скасування</span>
            <p class="content">{{ redistributionRequest.reasonForCancellation }}</p>
          </div>
        </div>
      </div>

    </div>

    <div class="table-holder">
      <div class="table-wrapper">
        <table>

          <thead>
            <tr>
              <th>Заклад охорони здоров'я</th>
              <th>Кількість у пропозиції</th>
              <th>Придатний до</th>
              <th>Серія/Кат. номер</th>
              <th>Статус</th>
              <th>Дата останньої зміни</th>
              <th>Зміни вніс</th>
            </tr>
          </thead>

          <tbody>
          <ng-container *ngIf="personalOfferings.length !== 0">
            <tr
                *ngFor="let item of personalOfferings"
                (click)="onOpenModalManagePersonalProposal(item)"
                [style.cursor]="'pointer'"
            >
              <td>{{  getOrganisationName(item.organizationId)  }}</td>
              <td>{{ item.offeredAmount }}</td>
              <td>{{ item.medicineMedicalDevice.dueDate | date : 'MM.yyyy' }}</td>
              <td>{{ item.medicineMedicalDevice.series }}</td>
              <td><app-personal-offer-status [status]="item.status"/></td>
              <td>{{ item.modifiedAt | date : 'dd-MM-yyyy H:mm' }}</td>
              <td>{{ item.modifiedBy ?  item.modifiedBy.firstName + ' ' +  item.modifiedBy.lastName : '-' }}</td>
            </tr>
          </ng-container>

          <ng-container *ngIf="personalOfferings.length === 0">
            <tr>
              <td [attr.colspan]="7" style="padding: 50px 0">
                <div class="error-cell-content">
                  <app-error
                      [errorCode]="404"
                      [customError]="{title: 'Реєстр не містить пропозицій', description: ' '}"
                  />
                </div>
              </td>
            </tr>
          </ng-container>

          </tbody>
        </table>
      </div>
    </div>
    <div class="table-footer">
      <div class="left">
<!--        <strong>Застосовані фільтри</strong> <span>{{ filterCount }}</span>-->
<!--        <div (click)="onResetFilters()" class="icon-container">-->
<!--          <med-icon-reset class="icon" size="16"></med-icon-reset>-->
<!--        </div>-->
      </div>
      <div class="right">
        <med-pagination
            *ngIf="pagination.totalElements > pagination.perPage"
            (pageChange)="onPageChange($event)"
            [page]="pagination.page"
            [perPage]="pagination.perPage"
            [total]="pagination.totalElements"
        ></med-pagination>
      </div>
    </div>
  </div>


  <!--  footer-->
  <app-quarantine-placement-footer>
    <div card-left>
      <button (click)="returnToList()" class="button footer-button-back">
      <span>
        <svg fill="none" height="13" viewBox="0 0 14 13" width="14" xmlns="http://www.w3.org/2000/svg">
          <path clip-rule="evenodd"
                d="M5.78033 0.969668C6.07322 1.26256 6.07322 1.73744 5.78033 2.03033L2.81066 5H9.25C11.8733 5 14 7.12663 14 9.75V12.25C14 12.6642 13.6642 13 13.25 13C12.8358 13 12.5 12.6642 12.5 12.25V9.75C12.5 7.95507 11.0449 6.5 9.25 6.5H2.81066L5.78033 9.4697C6.07322 9.7626 6.07322 10.2374 5.78033 10.5303C5.48744 10.8232 5.01256 10.8232 4.71967 10.5303L0.469668 6.28033C0.176777 5.98744 0.176777 5.51256 0.469668 5.21967L4.71967 0.969668C5.01256 0.676777 5.48744 0.676777 5.78033 0.969668Z"
                fill="white"
                fill-rule="evenodd"/>
        </svg>
      </span>
        Відмінити
      </button>
    </div>


    <div card-right>
      <ng-container  *ngIf="isActiveRequest && canCancelRequest">
        <button (click)="onCancelRedistributionRequest()" class="button footer-button-back">
       <span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_31165_6734)">
              <path d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2Z" fill="white"/>
              <rect x="11.8984" y="3" width="2" height="14" transform="rotate(45 11.8984 3)" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_31165_6734">
              <rect width="16" height="16" fill="white"/>
              </clipPath>
              </defs>
            </svg>
          </span>
          Скасувати
        </button>
      </ng-container>
      <ng-container *ngIf="isActiveRequest">
        <button class="button footer-button-yellow" (click)="openModalPutPersonalProposal()">
          Висунути пропозицію
          <span>
          <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 2L13 8M13 8L7 14M13 8L2 8" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="2"/>
          </svg>
        </span>
        </button>
      </ng-container>
    </div>
  </app-quarantine-placement-footer>
</div>

<app-loading-animation *ngIf="isLoading"></app-loading-animation>

<app-modal-put-personal-proposal [redistributionRequest]="redistributionRequest"  (updateData)="getData()"/>
<app-modal-manage-personal-proposal [redistributionRequest]="redistributionRequest" [personalOffer]="activeOffering" (onReject)="onReject()" (onCancel)="onCancel()" (updateData)="getData()"/>
<app-modal-reject-personal-proposal [personalOffer]="activeOffering"  (updateData)="getData()"/>
<app-modal-cancel-personal-proposal [personalOffer]="activeOffering" (updateData)="getData()"/>
<app-cancel-redistribution-request  [redistributionRequest]="redistributionRequest" (updateData)="getData()"/>
